import ax from '../axios'
import {API_URL} from "../index";

const STORY_ANSWER_LOG_URL = API_URL.QUESTION_MODULE+"/question-answer-log";

const getStoryAnswerLogs = (query: string) => {
    return ax.get(`${STORY_ANSWER_LOG_URL}?${query}`)
}

export {
    getStoryAnswerLogs
}
